<template>
  <div>
    <div class="header">
      <h4>SAML</h4>
      <div class="buttons">
        <el-button
          type="primary"
          @click="generateSAMLMetadata"
          size="mini"
          icon="el-icon-plus"
          round
          :loading="loading"
          >Generate SAML metadata</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useStore } from "@/store";
import { useNotify } from "@/utils/notify";

export default defineComponent({
  name: "saml",
  setup() {
    const { dispatch } = useStore();

    const loading = ref(false);

    const { success, error } = useNotify();

    const generateSAMLMetadata = async () => {
      loading.value = true;
      try {
        await dispatch("enterprise/generateSAMLMetadata");
        success("SAML metadata generated successfully");
      } catch (err) {
        error("Failed to generate SAML metadata");
      } finally {
        loading.value = false;
      }
    };


    return {
      loading,
      generateSAMLMetadata,
    };
  },
});
</script>

<style scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 10px 0;
}
h4 {
  margin-right: 10px;
}
</style>

